import { type MessageOptions } from 'element-plus'

export const useMessageStore = defineStore('messageData', () => {
  const messageStack = ref<MessageOptions[]>([])
  const storedCMDStack = ref<string[]>([])
  const isRunning = ref(false)

  const runMessage = () => {
    if (isRunning.value) { return }
    isRunning.value = true
    const messageData = messageStack.value.shift()
    if (messageData) {
      ElMessage(messageData)
      setTimeout(() => {
        isRunning.value = false
        runMessage()
      }, messageData.duration)
    } else {
      isRunning.value = false
    }
  }

  return {
    messageStack,
    storedCMDStack,
    runMessage
  }
})
